(function () {
  'use strict';
  const instances = new WeakMap();
  function init(footer) {
    if (instances.has(footer)) return;
    const controller = new AbortController(), signal = controller.signal;
    // The homepage has a floating logo. Let the footer own the brand area once
    // it reaches that corner, so it cannot cover the email field on small screens.
    const floatingHeader = document.querySelector('.site-header');
    if (floatingHeader) {
      let scrollFrame = 0;
      function syncFloatingLogo() {
        scrollFrame = 0;
        const bounds = footer.getBoundingClientRect();
        floatingHeader.classList.toggle('m09-footer-overlap', bounds.top < 110 && bounds.bottom > 0);
      }
      function scheduleLogo() { if (!scrollFrame) scrollFrame = requestAnimationFrame(syncFloatingLogo); }
      window.addEventListener('scroll',scheduleLogo,{passive:true,signal:signal});
      window.addEventListener('resize',scheduleLogo,{passive:true,signal:signal});
      signal.addEventListener('abort',function(){cancelAnimationFrame(scrollFrame);floatingHeader.classList.remove('m09-footer-overlap');},{once:true});
      syncFloatingLogo();
    }
    const mobile = window.matchMedia('(max-width:700px)');
    const groups = Array.from(footer.querySelectorAll('.m09-nav'));
    function layout() {
      groups.forEach(function (group) {
        if (mobile.matches && group.contains(document.activeElement)) group.querySelector('summary').focus();
        group.open = !mobile.matches;
        const summary = group.querySelector('summary');
        if (mobile.matches) summary.removeAttribute('tabindex');
        else summary.setAttribute('tabindex','-1');
      });
    }
    groups.forEach(function(group) {
      group.querySelector('summary').addEventListener('click', function(event) {
        if (!mobile.matches) event.preventDefault();
      }, {signal:signal});
    });
    mobile.addEventListener('change',layout,{signal:signal});
    layout();
    instances.set(footer,controller);
  }
  function scan(root) {
    if(root.matches && root.matches('.m09-footer'))init(root);
    root.querySelectorAll('.m09-footer').forEach(init);
  }
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',function(){scan(document);},{once:true});
  else scan(document);
  document.addEventListener('shopify:section:load',function(event){scan(event.target);});
  document.addEventListener('shopify:section:unload',function(event){
    const sections=event.target.matches('.m09-footer')?[event.target]:Array.from(event.target.querySelectorAll('.m09-footer'));
    sections.forEach(function(footer){instances.get(footer)?.abort();instances.delete(footer);});
  });
}());
